<template>
  <div class="mql-datefilter">
    <mql-textradio-group v-model="textValue" @change="textValueChange">
      <mql-textradio :label="0">今天</mql-textradio>
      <mql-textradio :label="1">本月</mql-textradio>
      <mql-textradio :label="2">近三月</mql-textradio>
      <mql-textradio :label="3">近一年</mql-textradio>
    </mql-textradio-group>
    <el-date-picker v-model="startDate" :type="type" :editable="false" placeholder="选择日期" :format="format" :value-format="valueFormat" :picker-options="pickerOptions" default-time="00:00:00" @change="changeEnd"></el-date-picker>
    <span class="text-split">至</span>
    <el-date-picker :editable="false" v-model="endDate" :type="type" placeholder="选择日期" :format="format" :value-format="valueFormat" default-time="23:59:00" @change="changeStart"></el-date-picker>
  </div>
</template>

<script>
import { DatePicker, TimeSelect, TimePicker } from "element-ui";
import { mapState } from "vuex";

export default {
  name: "MqlDatefilterClone",
  components: {
    elDatePicker: DatePicker,
    elTimeSelect: TimeSelect,
    elTimePicker: TimePicker,
  },
  computed: {
    ...mapState(["serverTime"]),
  },
  props: {
    type: {
      type: String,
      default: "datetime",
      validator: function(value) {
        return ["datetime", "date"].indexOf(value) !== -1;
      },
    },
    childCom: {
      type: Number,
      default: 1,
    },
    format: {
      type: String,
      default: function() {
        return this.type === "datetime" ? "yyyy-MM-dd HH:mm:ss" : "yyyy-MM-dd";
      },
    },
    valueFormat: {
      type: String,
      default: "timestamp",
    },
  },
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          let curDate = new Date().toString();
          let curDateYear = new Date().getFullYear();
          let curYearOneDate = curDate.replace(curDateYear, curDateYear - 2);
          let oneYear = new Date(curYearOneDate).getTime();
          return time.getTime() < oneYear;
        },
      },
      currentValue: this.value === undefined || this.value === null ? [] : this.value,
      textValue: 1,
      pickerOptionsStart: {},
      pickerOptionsEnd: {},
      startDate: this.$moment()
        .startOf("day")
        .valueOf(),
      endDate: this.$moment().valueOf(),
      inputFormat: this.valueFormat,
      localServerTime: null,
    };
  },
  watch: {
    currentValue: {
      handler(val) {
        this.$emit("change", val);
        this.$emit("input", val);
      },
      deep: true,
    },
  },
  mounted() {
    if (this.childCom == 0) this.textValue = 0;

    this.localServerTime = this.serverTime || JSON.parse(localStorage.getItem("serverTime"));
    this.textValueChange();
    if (this.valueFormat !== "timestamp") {
      this.inputFormat = this.valueFormat.replace(/yyyy|dd/g, (word) => word.toUpperCase());
    }
  },
  methods: {
    textValueChange() {
      const textValue = this.textValue;
      let startDate = "";
      let endDate = "";
      switch (textValue) {
        case 0:
          startDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0])).startOf("day");
          endDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0])).startOf("day");
          break;
        case 1:
          startDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0])).startOf("month");
          endDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0])).startOf("day");
          break;
        case 2:
          startDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0]))
            .subtract(3, "month")
            .startOf("month");
          endDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0])).startOf("day");
          break;
        case 3:
          startDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0]))
            .subtract(12, "month")
            .startOf("month");
          endDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0])).startOf("day");
          break;
        // case 4:
        //   startDate = this.$moment(new Date(this.localServerTime.date.split(' ')[0])).startOf("month");
        //   endDate = this.$moment(new Date(this.localServerTime.date.split(' ')[0])).startOf("day");
        //   break;
      }

      this.startDate = this.valueFormat === "timestamp" ? startDate.valueOf() : startDate.format(this.inputFormat);
      this.endDate = this.valueFormat === "timestamp" ? endDate.valueOf() : endDate.format(this.inputFormat);
      this.updateValue();
    },
    /**
     * 更新结束日期后触发
     */
    changeStart() {
      if (this.startDate && this.endDate) {
        if (this.endDate < this.startDate) {
          this.startDate = this.endDate;
        }
        this.updateTextValue();
      }

      this.pickerOptionsStart = Object.assign({}, this.pickerOptionsStart, {
        disabledDate: (time) => {
          return this.endDate && time.getTime() > this.endDate;
        },
      });

      this.updateValue();
    },
    /**
     * 更新开始日期后触发
     */
    changeEnd() {
      if (this.startDate && this.endDate) {
        if (this.endDate < this.startDate) {
          this.endDate = this.startDate;
        }
        this.updateTextValue();
      }

      this.pickerOptionsEnd = Object.assign({}, this.pickerOptionsEnd, {
        disabledDate: (time) => {
          return this.startDate && time.getTime() < this.startDate;
        },
      });
      this.updateValue();
    },
    /**
     * 更新文本单选值
     */
    updateTextValue() {
      const endDate = this.$moment(new Date(this.localServerTime.date.split(" ")[0])).valueOf();

      if (endDate === this.endDate) {
        if (
          this.startDate ===
          this.$moment(new Date(this.localServerTime.date.split(" ")[0]))
            .startOf("day")
            .valueOf()
        ) {
          this.textValue = 1;
        } else if (
          this.startDate ===
          this.$moment(new Date(this.localServerTime.date.split(" ")[0]))
            .subtract(2, "days")
            .startOf("day")
            .valueOf()
        ) {
          this.textValue = 2;
        } else if (
          this.startDate ===
          this.$moment(new Date(this.localServerTime.date.split(" ")[0]))
            .subtract(6, "days")
            .startOf("day")
            .valueOf()
        ) {
          this.textValue = 3;
        } else if (
          this.startDate ===
          this.$moment(new Date(this.localServerTime.date.split(" ")[0]))
            .startOf("month")
            .valueOf()
        ) {
          this.textValue = 4;
        }
      }
    },
    /**
     * 更新当前选择时间
     */
    updateValue() {
      if (this.endDate && this.type === "date") {
        if (this.valueFormat === "timestamp") {
          this.endDate = this.$moment(this.endDate)
            .endOf("day")
            .valueOf();
        } else {
          this.endDate = this.$moment(this.endDate, this.inputFormat)
            .endOf("day")
            .format(this.inputFormat);
        }
      }
      this.currentValue = [this.startDate || "", this.endDate || ""];
    },
  },
};
</script>

<style lang="scss" scoped>
.mql-datefilter {
  /deep/ .el-input {
    width: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/core/MqlDatefilterClone/index.vue